// @flow

import auditLogTableConfiguration from './components/configuration/autidLogTableConfiguration';
import auditLogTableRowExtension from './components/table/AuditLogTableRowExtension';

export const components = {
    'configuration:CORE_ENTITY_AUDIT_LOG_ENTRIES_TABLE': auditLogTableConfiguration,
    'tableRowExtension:CORE_ENTITY_AUDIT_LOG_ENTRIES_TABLE': auditLogTableRowExtension,
}
